import React, {useCallback, useState} from 'react';
import {HTMLDialog, Flex, Button} from '@priority-software/priority-style-react';
import {DialogToolbarContent} from '../../../../../../components/Dialog/DialogToolbar/DialogToolbar';
import {ScrollableList} from './parts/ScrollableList/ScrollableList';
import texts from '../../../../texts';
import styles from './styles.module.scss';
import {monitorAction} from '../../../../../../services/datadog';
import {HomepageMonitoring} from '../../../../../../constants/monitoring';

export const AddPortletDialog = (props: {
    closeDialog: () => void;
    onSave: (id: string, title: string) => void;
    data: {title: string; exec: string}[];
}) => {
    const {closeDialog, onSave, data} = props;
    const [options] = useState(data?.map(item => ({label: item.title, value: item.exec})) || []);
    const [selectedItem, setSelectedItem] = useState(options[0] || null);

    const onItemClick = useCallback(item => {
        setSelectedItem(item);
    }, []);

    const handleSave = () => {
        onSave(selectedItem?.value, selectedItem?.label);
        monitorAction(HomepageMonitoring.addPortlet);
    };

    return (
        <HTMLDialog
            isOpen
            onClose={closeDialog}
            width={720}
            componentClasses={styles.component}
            toolbarContent={<DialogToolbarContent mainTitle={texts.add_portlet_title} />}
            content={
                <div style={{height: '100%', display: 'flex', overflow: 'hidden'}}>
                    <ScrollableList
                        data={options}
                        onItemClick={onItemClick}
                        showSearch={false}
                        selectedValue={selectedItem?.value}
                        noOptionsText={texts.widget_list_empty}
                    />
                </div>
            }
            footer={
                <Flex justifyContent="flex-end" style={{gap: 24}}>
                    <Button onClick={closeDialog} wideButton skin="secondary" size="medium">
                        {texts.btn_cancel}
                    </Button>
                    <Button
                        onClick={handleSave}
                        wideButton
                        skin="primary"
                        size="medium"
                        disabled={!selectedItem}
                    >
                        {texts.btn_add}
                    </Button>
                </Flex>
            }
        />
    );
};
